import Vue from 'vue'
import App from './App.vue'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)

import animated from 'animate.css'
Vue.use(animated);

Vue.config.productionTip = false
    // Vue.use(ElementUI);


new Vue({
    render: h => h(App),
}).$mount('#app')